import { useState } from 'react';
import { AppLayout } from '@/components/AppLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Users, FileText, ShoppingCart } from 'lucide-react';
import { CustomersList } from '@/components/customers/CustomersList';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { OrdersList } from '@/components/customers/OrdersList';
import { InvoicesList } from '@/components/customers/InvoicesList';

export default function Wholesale() {
  const [activeTab, setActiveTab] = useState('invoices');

  return (
    <AppLayout currentPage="wholesale">
      <div className="container-responsive space-y-6">
        <div className="space-y-2">
          <h1 className="mobile-heading">Wholesale Management</h1>
          <p className="mobile-body text-muted-foreground">
            Manage wholesale customers, orders, and invoices
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-3 sm:space-y-4">
          <TabsList className="grid w-full grid-cols-3 h-auto">
            <TabsTrigger value="invoices" className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm px-2 py-2 sm:px-4 sm:py-2.5">
              <FileText className="h-3 w-3 sm:h-4 sm:w-4" />
              <span>Invoices</span>
            </TabsTrigger>
            <TabsTrigger value="orders" className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm px-2 py-2 sm:px-4 sm:py-2.5">
              <ShoppingCart className="h-3 w-3 sm:h-4 sm:w-4" />
              <span>Orders</span>
            </TabsTrigger>
            <TabsTrigger value="customers" className="flex items-center gap-1 sm:gap-2 text-xs sm:text-sm px-2 py-2 sm:px-4 sm:py-2.5">
              <Users className="h-3 w-3 sm:h-4 sm:w-4" />
              <span className="hidden xs:inline">Customers</span>
              <span className="xs:hidden">Cust</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="invoices" className="space-y-4">
            <ErrorBoundary>
              <InvoicesList />
            </ErrorBoundary>
          </TabsContent>

          <TabsContent value="orders" className="space-y-4">
            <ErrorBoundary>
              <OrdersList />
            </ErrorBoundary>
          </TabsContent>

          <TabsContent value="customers" className="space-y-4">
            <ErrorBoundary>
              <CustomersList />
            </ErrorBoundary>
          </TabsContent>
        </Tabs>
      </div>
    </AppLayout>
  );
}